// Add your custom JS here.

// Run fn now if the DOM is already parsed, otherwise on DOMContentLoaded. NitroPack delays this
// file until first interaction, so DOMContentLoaded has usually fired before it executes.
function onReady(fn) {
	if (document.readyState !== 'loading') {
		fn();
	} else {
		document.addEventListener('DOMContentLoaded', fn);
	}
}
jQuery(window).scroll(function () {
	if (jQuery(this).scrollTop() > 50) {
		jQuery('header.header-site').addClass('scrolled');
	} else {
		jQuery('header.header-site').removeClass('scrolled');
	}
});

// Mobile menu dropdown toggle
(function ($) {
	$(function () {
		var $mobileNav = $('#navbarMobile');
		if (!$mobileNav.length) return;

		$mobileNav.find('.menu-item-has-children').each(function () {
			var $item = $(this);

			// Guard: avoid double-init if script runs again
			if ($item.data('dropdown-init')) return;
			$item.data('dropdown-init', true);

			var $link = $item.find('> a');
			var $dropdown = $item.find('> .dropdown-menu');

			// Hide the legacy span generated by the navwalker
			$item.find('> .drop-down-icon-mobile').hide();

			// Create accessible toggle button
			var $toggle = $(
				'<button type="button" class="dropdown-arrow-toggle" aria-expanded="false" aria-label="Toggle submenu"></button>',
			);
			$link.after($toggle);

			$toggle.on('click', function (e) {
				e.preventDefault();
				e.stopPropagation();

				var isOpen = $toggle.hasClass('open');

				if (isOpen) {
					$dropdown.slideUp(300);
					$toggle.removeClass('open').attr('aria-expanded', 'false');
					$link.removeClass('show');
				} else {
					$dropdown.slideDown(300);
					$toggle.addClass('open').attr('aria-expanded', 'true');
					$link.addClass('show');
				}
			});
		});
	});
})(jQuery);

jQuery(document).ready(function ($) {});

jQuery(document).ready(function ($) {
	$('[tabindex="0"]').keydown(function (event) {
		if (event.key === 'Enter' || event.key === ' ') {
			$(this).click();
		}
	});
});

/*skip content*/
document.addEventListener('DOMContentLoaded', function () {
	const LinkGoSecondSection = document.getElementById('GoSecondSection');
	LinkGoSecondSection.addEventListener('click', function (event) {
		event.preventDefault();
		const secondSection = document.querySelector(
			'.general-section:nth-of-type(2)',
		);
		if (secondSection) {
			secondSection.scrollIntoView({behavior: 'smooth'});
		} else {
			console.error('the second section was not found.');
		}
	});
});

function autosize() {
	var el = this;
	setTimeout(function () {
		el.style.cssText = 'height:auto; padding:0';
		// for box-sizing other than "content-box" use:
		// el.style.cssText = '-moz-box-sizing:content-box';
		el.style.cssText = 'height:' + (el.scrollHeight + 2) + 'px';
	}, 0);
}

document.fonts.ready.then(function () {
	document.body.classList.add('font-loaded');
	if (typeof ScrollTrigger !== 'undefined') {
		ScrollTrigger.refresh();
	}
});

window.addEventListener('load', function () {
	if (typeof ScrollTrigger !== 'undefined') {
		ScrollTrigger.refresh();
	}
});

// Search Filter Featured — scroll to results after filter/pagination reload
document.addEventListener('DOMContentLoaded', function () {
	var section = document.querySelector('.search-filter-featured');
	if (!section) return;

	var resultsEl = section.querySelector('.sff-results');
	if (!resultsEl) return;

	// Flag that the next page load should scroll to results (pagination or filter)
	section.addEventListener('click', function (e) {
		if (e.target.closest('.sff-pagination a')) {
			sessionStorage.setItem('sff-should-scroll', '1');
		}
	});

	var filterBar = section.querySelector('.sff-filter-bar');
	if (filterBar) {
		filterBar.addEventListener('change', function () {
			sessionStorage.setItem('sff-should-scroll', '1');
		});
		filterBar.addEventListener('click', function (e) {
			if (e.target.closest('button, input, select, label, a')) {
				sessionStorage.setItem('sff-should-scroll', '1');
			}
		});
	}

	// Scroll if: URL has params/pagination, or comes from a previous interaction
	var hasFilters = window.location.search !== '';
	var hasPagination = /\/page\/\d+/i.test(window.location.pathname);
	var fromNav = sessionStorage.getItem('sff-should-scroll') === '1';

	if (hasFilters || hasPagination || fromNav) {
		sessionStorage.removeItem('sff-should-scroll');
		var offset = window.innerWidth < 992 ? 100 : 130;
		setTimeout(function () {
			var top =
				resultsEl.getBoundingClientRect().top +
				window.pageYOffset -
				offset;
			window.scrollTo({top: top, behavior: 'smooth'});
		}, 150);
	}
});

// Search Filter Featured — AJAX without page reload (fallback if plugin does not navigate)
(function () {
	'use strict';

	document.addEventListener('DOMContentLoaded', function () {
		var section = document.querySelector('.search-filter-featured');
		if (!section) return;

		var filterForm = section.querySelector('.sff-filter-bar form');
		var resultsEl = section.querySelector('.sff-results');
		if (!filterForm || !resultsEl) return;

		var timer = null;
		var fetching = false;

		function scrollToResults() {
			var offset = window.innerWidth < 992 ? 100 : 130;
			var top =
				resultsEl.getBoundingClientRect().top +
				window.pageYOffset -
				offset;
			window.scrollTo({top: top, behavior: 'smooth'});
		}

		function fetchResults(url, scroll) {
			if (fetching) return;
			fetching = true;
			resultsEl.classList.add('sff-results--loading');

			fetch(url, {credentials: 'same-origin'})
				.then(function (r) {
					return r.text();
				})
				.then(function (html) {
					var doc = new DOMParser().parseFromString(
						html,
						'text/html',
					);
					var fresh = doc.querySelector(
						'.search-filter-featured .sff-results',
					);
					if (fresh) {
						resultsEl.innerHTML = fresh.innerHTML;
						history.pushState(null, '', url);
						if (scroll) scrollToResults();
					}
				})
				.catch(function () {})
				.finally(function () {
					fetching = false;
					resultsEl.classList.remove('sff-results--loading');
					if (typeof AOS !== 'undefined') AOS.refreshHard();
				});
		}

		function buildUrl() {
			var params = new URLSearchParams(
				new FormData(filterForm),
			).toString();
			return window.location.pathname + (params ? '?' + params : '');
		}

		// Prevent default form submission (avoid page reload)
		filterForm.addEventListener('submit', function (e) {
			e.preventDefault();
			fetchResults(buildUrl(), true);
		});

		// Live filter on select / checkbox change
		filterForm.addEventListener('change', function () {
			clearTimeout(timer);
			timer = setTimeout(function () {
				fetchResults(buildUrl(), true);
			}, 350);
		});

		// Live search on text inputs (longer debounce)
		filterForm.addEventListener('input', function (e) {
			if (e.target.type === 'text' || e.target.type === 'search') {
				clearTimeout(timer);
				timer = setTimeout(function () {
					fetchResults(buildUrl(), true);
				}, 600);
			}
		});

		// Pagination without reload (event delegation since DOM gets replaced)
		section.addEventListener('click', function (e) {
			var link = e.target.closest('.sff-pagination a.page-numbers');
			if (!link) return;
			e.preventDefault();
			fetchResults(link.href, true);
		});
	});
})();

// AOS (Animate On Scroll) refresh on AJAX content load
document.addEventListener('DOMContentLoaded', function () {
	if (typeof AOS === 'undefined') return;
	jQuery(document).on('sf:ajaxfinish', function () {
		AOS.refreshHard();
	});

	var target = document.querySelector('#block-search-and-filter');
	if (target) {
		var resizeObserver = new ResizeObserver(function () {
			AOS.refreshHard();
		});
		resizeObserver.observe(target);
	}
});

//  Smooth scroll for hash links
// document.addEventListener("DOMContentLoaded", function () {
//     const isMobile = window.innerWidth < 992;
//     const offset = isMobile ? 180 : 230;

//     function scrollToHash(hash) {
//         const el = document.querySelector(hash);
//         if (el) {
//             setTimeout(() => {
//                 window.scrollTo({
//                     top:
//                         el.getBoundingClientRect().top +
//                         window.pageYOffset -
//                         offset,
//                     behavior: "smooth",
//                 });
//             }, 50);
//         }
//     }

//     if (window.location.hash) {
//         scrollToHash(window.location.hash);
//     }

//     document.querySelectorAll('a[href^="#"]').forEach((link) => {
//         link.addEventListener("click", function (e) {
//             const hash = this.getAttribute("href");
//             if (hash.length > 1) {
//                 e.preventDefault();
//                 history.pushState(null, null, hash);
//                 scrollToHash(hash);
//             }
//         });
//     });
// });

// Header Buttons in Mega Menu Mobile
document.addEventListener('DOMContentLoaded', function () {
	const headerButtons = document.querySelector('.header-buttons');
	const megaMenu = document.querySelector('#mega-menu-primary');

	const liButtons = document.createElement('li');
	liButtons.className =
		'mega-menu-item mega-menu-item-type-custom mega-align-bottom-left mega-menu-flyout menu-item-header-buttons';

	let isInMegaMenu = false;

	function moveButtonsToMenu() {
		if (window.innerWidth <= 1000 && !isInMegaMenu) {
			if (headerButtons && megaMenu) {
				liButtons.appendChild(headerButtons);
				megaMenu.appendChild(liButtons);
				isInMegaMenu = true;
			}
		} else if (window.innerWidth > 1000 && isInMegaMenu) {
			const originalContainer =
				document.querySelector('.content-elements');
			if (originalContainer && headerButtons) {
				originalContainer.appendChild(headerButtons);
				if (liButtons.parentNode)
					liButtons.parentNode.removeChild(liButtons);
				isInMegaMenu = false;
			}
		}
	}

	moveButtonsToMenu();
	window.addEventListener('resize', moveButtonsToMenu);
});

// Lenis Smooth Scroll
// document.addEventListener("DOMContentLoaded", function () {
//     // Initialize Lenis
//     const lenis = new Lenis({
//         autoRaf: true,
//     });

//     // Listen for the scroll event and log the event data
//     lenis.on("scroll", (e) => {
//         console.log(e);
//     });
// });

// Highlights Stats - Counter animation on scroll into view
function initStatsCounters() {
	// Skip grids already initialized (handles multiple calls on same page)
	const statGrids = document.querySelectorAll(
		'.highlights-stats__stats-grid:not([data-counter-init])',
	);
	if (!statGrids.length) return;

	function animateCounter(el, duration) {
		if (el.dataset.counterDone) return;
		el.dataset.counterDone = 'true';

		const raw = el.dataset.counterTarget;
		const target = parseFloat(raw);
		if (isNaN(target)) return;
		const decimals = raw.includes('.') ? raw.split('.')[1].length : 0;
		const start = performance.now();

		function update(now) {
			const progress = Math.min((now - start) / duration, 1);
			const eased = 1 - Math.pow(1 - progress, 3);
			el.textContent =
				decimals > 0
					? (eased * target).toFixed(decimals)
					: Math.round(eased * target).toString();
			if (progress < 1) requestAnimationFrame(update);
		}

		requestAnimationFrame(update);
	}

	statGrids.forEach(function (grid) {
		grid.dataset.counterInit = 'true';

		// Cache target values before any animation mutates the text
		grid.querySelectorAll('.stat-card__value').forEach(function (el) {
			el.dataset.counterTarget = el.textContent.trim();
			el.textContent = '0';
		});

		// One observer per grid — disconnect() won't affect sibling grids
		const observer = new IntersectionObserver(
			function (entries) {
				if (!entries[0].isIntersecting) return;
				observer.disconnect();
				grid.querySelectorAll('.stat-card__value').forEach(
					function (el) {
						animateCounter(el, 2000);
					},
				);
			},
			{threshold: 0.3},
		);

		observer.observe(grid);
	});
}

onReady(initStatsCounters);

// Search Filter Featured — Swiper slider
onReady(function () {
	document.querySelectorAll('.sff-featured__swiper').forEach(function (el) {
		var loop = el.dataset.loop === 'true';
		var delay = parseInt(el.dataset.autoplay, 10) || 0;
		var prevEl = el.dataset.prevId
			? document.getElementById(el.dataset.prevId)
			: null;
		var nextEl = el.dataset.nextId
			? document.getElementById(el.dataset.nextId)
			: null;

		var config = {
			slidesPerView: 1,
			spaceBetween: 40,
			loop: loop,
			speed: 700,
			autoplay: delay
				? {delay: delay, disableOnInteraction: false}
				: false,
		};

		if (prevEl && nextEl) {
			config.navigation = {prevEl: prevEl, nextEl: nextEl};
		}

		new Swiper(el, config);
	});
});

// GSAP text reveal for .test-text
onReady(function () {
	if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined')
		return;

	gsap.registerPlugin(ScrollTrigger);

	document.querySelectorAll('.js-reveal-text p').forEach(function (el) {
		function wrapWords(node) {
			if (node.nodeType === 3) {
				var frag = document.createDocumentFragment();
				node.textContent.split(/(\s+)/).forEach(function (part) {
					if (part.match(/\S/)) {
						var span = document.createElement('span');
						span.className = 'gsap-word';
						span.textContent = part;
						frag.appendChild(span);
					} else {
						frag.appendChild(document.createTextNode(part));
					}
				});
				node.parentNode.replaceChild(frag, node);
			} else if (node.nodeType === 1) {
				Array.from(node.childNodes).forEach(wrapWords);
			}
		}

		wrapWords(el);

		var words = el.querySelectorAll('.gsap-word');

		gsap.fromTo(
			words,
			{opacity: 0.1},
			{
				opacity: 1,
				ease: 'none',
				stagger: {each: 0.015, from: 'start'},
				scrollTrigger: {
					trigger: el,
					start: 'top 85%',
					end: 'bottom 20%',
					scrub: 0.5,
				},
			},
		);
	});
});

// Focus the auxiliary location with its own zoom
document.addEventListener('DOMContentLoaded', () => {
	const map = document.querySelector('mapplic-map');
	if (!map) return;

	let attempts = 0;
	const waitForStore = setInterval(() => {
		attempts++;
		const state = map.store?.getState?.();
		if (state?.openLocation) {
			clearInterval(waitForStore);

			// Optional: force the layer before focusing
			if (typeof state.switchLayer === 'function') {
				state.switchLayer('layer1');
			}

			// Focus the auxiliary location with its own zoom
			state.openLocation('init-west');

			// Close the focus to not leave popup/sidebar open.
			window.setTimeout(() => {
				if (typeof state.closeLocation === 'function') {
					state.closeLocation();
				}
			}, 50);
		}
		if (attempts > 60) clearInterval(waitForStore);
	}, 500);
});

// Search & Filter Combobox Capitalizer (converts all-caps text like "FREIGHT TIPS" to "Freight Tips")
document.addEventListener('DOMContentLoaded', function () {
	const targetSelector =
		'.search-filter-component-combobox__selection, .search-filter-component-combobox-base__listbox-option';

	function toTitleCase(str) {
		return str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
	}

	function formatElement(el) {
		if (el.dataset.formattingInProgress) return;
		el.dataset.formattingInProgress = 'true';

		Array.from(el.childNodes).forEach((node) => {
			if (node.nodeType === Node.TEXT_NODE) {
				const text = node.nodeValue.trim();
				if (text) {
					const formatted = toTitleCase(text);
					if (text !== formatted) {
						node.nodeValue = node.nodeValue.replace(
							text,
							formatted,
						);
					}
				}
			}
		});

		delete el.dataset.formattingInProgress;
	}

	// Format existing elements
	document.querySelectorAll(targetSelector).forEach(formatElement);

	// Observe changes for dynamic updates (selection clicks, AJAX loads)
	const observer = new MutationObserver((mutations) => {
		mutations.forEach((mutation) => {
			if (mutation.type === 'characterData') {
				const parent = mutation.target.parentElement;
				if (
					parent &&
					(parent.classList.contains(
							'search-filter-component-combobox__selection',
						) ||
						parent.classList.contains(
							'search-filter-component-combobox-base__listbox-option',
						))
				) {
					formatElement(parent);
				}
			} else if (mutation.type === 'childList') {
				mutation.addedNodes.forEach((node) => {
					if (node.nodeType === Node.ELEMENT_NODE) {
						if (
							node.classList.contains(
								'search-filter-component-combobox__selection',
							) ||
							node.classList.contains(
								'search-filter-component-combobox-base__listbox-option',
							)
						) {
							formatElement(node);
						}
						node.querySelectorAll(targetSelector).forEach(
							formatElement,
						);
					} else if (node.nodeType === Node.TEXT_NODE) {
						const parent = node.parentElement;
						if (
							parent &&
							(parent.classList.contains(
									'search-filter-component-combobox__selection',
								) ||
								parent.classList.contains(
									'search-filter-component-combobox-base__listbox-option',
								))
						) {
							formatElement(parent);
						}
					}
				});
			}
		});
	});

	const searchFilterContainer =
		document.querySelector('.search-filter-featured') || document.body;
	observer.observe(searchFilterContainer, {
		childList: true,
		subtree: true,
		characterData: true,
	});
});

// Dynamic scroll
document.addEventListener('DOMContentLoaded', () => {
	const OFFSET = 120;
	document.querySelectorAll('section > div[id]').forEach((target) => {
		if (
			target.id.includes('-offset') ||
			target.classList.contains('anchor-offset')
		) {
			return;
		}

		const offsetId = `${target.id}-offset`;
		if (document.getElementById(offsetId)) {
			return;
		}

		const offset = document.createElement('div');

		offset.id = offsetId;
		offset.className = 'anchor-offset';
		offset.style.position = 'relative';
		offset.style.top = `-${OFFSET}px`;
		offset.style.visibility = 'hidden';
		offset.style.pointerEvents = 'none';

		target.parentNode.insertBefore(offset, target);
	});

	document.querySelectorAll('a[href*="#"]').forEach((link) => {
		const href = link.getAttribute('href');

		if (!href || href === '#') return;

		const parts = href.split('#');

		if (!parts[1]) return;

		const hash = parts[1];
		const offsetId = `${hash}-offset`;

		if (href.startsWith('#')) {
			link.setAttribute('href', `#${offsetId}`);
		} else {
			link.setAttribute('href', `${parts[0]}#${offsetId}`);
		}
	});
});

// Video modal for buttons with the class .btn-icon-play
(function ($) {
	$(function () {
		// Create the modal elements dynamically
		var modalHTML =
			'<div class="video-modal" id="customVideoModal">' +
			'    <div class="video-modal-overlay"></div>' +
			'    <div class="video-modal-container">' +
			'        <button type="button" class="video-modal-close" aria-label="Close modal">&times;</button>' +
			'        <div class="video-modal-ratio">' +
			'            <!-- Video content will be inserted dynamically -->' +
			'        </div>' +
			'    </div>' +
			'</div>';

		// Append modal to body if not already present
		var $modal = $('#customVideoModal');
		if (!$modal.length) {
			$modal = $(modalHTML);
			$('body').append($modal);
		}

		var $ratioContainer = $modal.find('.video-modal-ratio');
		var $closeBtn = $modal.find('.video-modal-close');
		var $overlay = $modal.find('.video-modal-overlay');

		// Helpers to parse video URLs
		function getYoutubeId(url) {
			var regExp =
				/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
			var match = url.match(regExp);
			return match && match[2].length === 11 ? match[2] : null;
		}

		function getVimeoId(url) {
			var regExp = /vimeo\.com\/(?:video\/)?([0-9]+)/;
			var match = url.match(regExp);
			return match ? match[1] : null;
		}

		function isDirectVideo(url) {
			return url.match(/\.(mp4|webm|ogv|mov)(\?|$)/i);
		}

		// Open modal and load video
		function openVideoModal(videoUrl) {
			var embedHTML = '';
			var ytId = getYoutubeId(videoUrl);
			var vimeoId = getVimeoId(videoUrl);

			if (ytId) {
				embedHTML =
					'<iframe src="https://www.youtube.com/embed/' +
					ytId +
					'?autoplay=1&mute=0&controls=1&rel=0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
				$ratioContainer.html(embedHTML);
			} else if (vimeoId) {
				embedHTML =
					'<iframe src="https://player.vimeo.com/video/' +
					vimeoId +
					'?autoplay=1&muted=0&controls=1" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>';
				$ratioContainer.html(embedHTML);
			} else if (isDirectVideo(videoUrl)) {
				embedHTML =
					'<video src="' +
					videoUrl +
					'" controls playsinline style="width:100%; height:100%; object-fit:contain;"></video>';
				$ratioContainer.html(embedHTML);
				var videoEl = $ratioContainer.find('video')[0];
				if (videoEl) {
					videoEl.play().catch(function () {
						console.log(
							'Autoplay with audio blocked by browser browser policy. User can play manually.',
						);
					});
				}
			} else {
				// Fallback to iframe for other links
				embedHTML =
					'<iframe src="' +
					videoUrl +
					'" allow="autoplay" allowfullscreen></iframe>';
				$ratioContainer.html(embedHTML);
			}

			$modal.addClass('active');
			$('body').css('overflow', 'hidden'); // Lock background scroll
		}

		// Close modal and remove video
		function closeVideoModal() {
			$modal.removeClass('active');
			$('body').css('overflow', ''); // Restore scroll
			setTimeout(function () {
				$ratioContainer.empty();
			}, 300);
		}

		// Event delegation: listen to clicks on any .btn-icon-play
		$(document).on('click', '.btn-icon-play', function (e) {
			var videoUrl = $(this).attr('href');
			if (
				videoUrl &&
				videoUrl !== '#' &&
				!videoUrl.startsWith('javascript:')
			) {
				e.preventDefault();
				openVideoModal(videoUrl);
			}
		});

		// Close events
		$closeBtn.on('click', closeVideoModal);
		$overlay.on('click', closeVideoModal);

		// Escape key to close modal
		$(document).on('keydown', function (e) {
			if (e.key === 'Escape' && $modal.hasClass('active')) {
				closeVideoModal();
			}
		});
	});
})(jQuery);